import React, { useEffect, useRef, useState } from "react";

const ARTICLES = [
  {
    id: 1,
    category: "Humanitarian Day",
    date: "August 19, 2025",
    headline:
      "DINGONET Leads National World Humanitarian Day 2025 Commemoration in Dodoma",
    excerpt:
      "DINGONET successfully organized Tanzania's national World Humanitarian Day 2025 in Dodoma, officiated by the Prime Minister's Office. The event convened government institutions, UN agencies, NGOs, and development partners to honor the work of humanitarian actors and reaffirm commitment to coordinated humanitarian action across Tanzania.",
    author: "DINGONET Secretariat",
    readTime: "4 min read",
    image: "/assets/event2.jpeg",
  },
  {
    id: 2,
    category: "Disaster Response",
    date: "October 12, 2024",
    headline:
      "DINGONET Members Mobilize for Flood Response in Kibiti and Rufiji Districts",
    excerpt:
      "Following severe flooding in Kibiti and Rufiji, DINGONET mobilized member organizations to conduct joint Damage and Needs Assessments alongside government authorities. The coordinated response ensured timely delivery of relief and prevented duplication of efforts across the affected areas, demonstrating the strength of network coordination.",
    author: "DINGONET Operations Team",
    readTime: "5 min read",
    image: "/assets/rufiji.jpeg",
  },
  {
    id: 3,
    category: "Disaster Response",
    date: "September 4, 2024",
    headline:
      "Rapid Coordination Deployed Following Kariakoo Building Collapse in Dar es Salaam",
    excerpt:
      "DINGONET activated its rapid response coordination mechanism following the Kariakoo building collapse in Dar es Salaam. Member organizations supported information sharing, search coordination, and emergency relief efforts — proving the network's capacity to respond effectively to sudden-onset urban disasters.",
    author: "DINGONET Emergency Desk",
    readTime: "3 min read",
    image: "/assets/kariakoo-pic3.jpg",
  },
  {
    id: 4,
    category: "Humanitarian Day",
    date: "August 19, 2024",
    headline:
      "DINGONET Hosts Inaugural World Humanitarian Day Commemoration at JICC Dar es Salaam",
    excerpt:
      "In its founding year, DINGONET coordinated the national commemoration of World Humanitarian Day 2024 at the Julius Nyerere International Convention Centre. The event was officiated by the Director of PMO-DMD and brought together hundreds of humanitarian actors for a landmark moment in Tanzania's disaster coordination history.",
    author: "DINGONET Secretariat",
    readTime: "4 min read",
    image: "/assets/event.jpeg",
  },
  {
    id: 5,
    category: "Announcement",
    date: "January 15, 2026",
    headline:
      "DINGONET Officially Registered as National NGO Network — Registration No. 8894",
    excerpt:
      "DINGONET has been officially registered under Registration Number 8894 by the Registrar of NGOs in Tanzania, effective January 2026. This milestone cements the network's legal status as a nationally recognized coordination platform for humanitarian and disaster management actors across the country.",
    author: "DINGONET Secretariat",
    readTime: "2 min read",
    image: "/assets/certificate.png",
  },
  {
    id: 6,
    category: "Coordination",
    date: "March 20, 2025",
    headline:
      "DINGONET Launches 3Ws Coordination Database for Tanzania Disaster Management Actors",
    excerpt:
      "DINGONET has initiated the development of an online 3Ws (Who does What, Where) coordination database for all disaster management stakeholders in Tanzania. The tool will enhance information sharing, reduce duplication, and enable faster joint response planning across the network.",
    author: "Information Management Unit",
    readTime: "3 min read",
    image: "/assets/event4.png",
  },
  {
    id: 7,
    category: "Preparedness",
    date: "May 10, 2025",
    headline:
      "Joint Disaster Simulation Exercise Conducted Across Three Regions by DINGONET Members",
    excerpt:
      "DINGONET members conducted a multi-agency disaster simulation exercise across three Tanzanian regions, testing coordination protocols, communication systems, and rapid response procedures. The drill strengthened inter-agency preparedness and identified key gaps for improvement in joint response planning.",
    author: "Preparedness Working Group",
    readTime: "4 min read",
    image: "/assets/event3.jpeg",
  },
  {
    id: 8,
    category: "Membership",
    date: "February 28, 2025",
    headline:
      "DINGONET Welcomes New Member Organizations — Network Grows to 20+ Partners",
    excerpt:
      "DINGONET has expanded its membership to over 20 national and international organizations following a successful recruitment drive in early 2025. New members bring expertise in health, WASH, protection, and food security — significantly strengthening the network's collective capacity for coordinated disaster response across Tanzania.",
    author: "DINGONET Secretariat",
    readTime: "3 min read",
    image: "/assets/event5.png",
  },
  {
    id: 9,
    category: "Coordination",
    date: "November 5, 2024",
    headline:
      "DINGONET Strengthens Ties with PMO-DMD for Joint Disaster Assessment Protocols",
    excerpt:
      "DINGONET and the Prime Minister's Office – Disaster Management Department held a joint technical meeting to align assessment protocols and coordination frameworks. The partnership strengthens government-NGO collaboration and ensures that joint damage and needs assessments follow nationally recognized standards.",
    author: "Government Liaison Office",
    readTime: "3 min read",
    image: "/assets/event6.png",
  },
  {
    id: 10,
    category: "Preparedness",
    date: "June 22, 2025",
    headline:
      "Capacity Building Workshop Held for Member NGOs on Disaster Risk Reduction Frameworks",
    excerpt:
      "DINGONET facilitated a two-day capacity building workshop for member organizations on the Sendai Framework for Disaster Risk Reduction and Tanzania's national DRR policies. Participants strengthened their understanding of risk assessment, early warning systems, and community resilience strategies applicable to their respective program areas.",
    author: "Training & Capacity Unit",
    readTime: "5 min read",
    image: "/assets/photo_2024-11-18_13-15-58.jpg",
  },
  {
    id: 11,
    category: "Announcement",
    date: "April 3, 2025",
    headline:
      "DINGONET Secretariat Releases First Annual Report Covering 2024 Network Activities",
    excerpt:
      "The DINGONET Secretariat has published its inaugural Annual Report, documenting all network activities, key achievements, financial status, and strategic priorities for 2024. The report is available to all member organizations and marks a significant step in the network's commitment to transparency and accountability.",
    author: "DINGONET Secretariat",
    readTime: "2 min read",
    image: "/assets/dingonet.jpeg",
  },
  {
    id: 12,
    category: "Membership",
    date: "August 1, 2023",
    headline:
      "Founding Meeting: Humanitarian Actors Agree to Establish Disaster NGO Network in Tanzania",
    excerpt:
      "At the World Humanitarian Day 2023 commemoration at Karimjee Hall, humanitarian actors from leading NGOs identified persistent gaps in disaster coordination and unanimously agreed to establish the Disaster NGOs Network – Tanzania (DINGONET). This founding moment marked the beginning of a new era of structured humanitarian coordination in Tanzania.",
    author: "DINGONET Founding Members",
    readTime: "3 min read",
    image: "/assets/event.jpeg",
  },
];

const LATEST_ACTIVITIES = [
  {
    id: 5,
    title: "RAIS SAMIA AAGIZA WAKUU WA MIKOA KUJIANDAA NA UDHIBITI WA ATHARI ZA ELNINO",
    url: "https://www.instagram.com/reel/DcV7nVwMXqk/?igsi=MzRuZ3cyZDQ2Nm9m",
    platform: "Instagram",
    thumbnail: "/assets/emblemoftanzania.png",
  },
  {
    id: 2,
    title:
      'UFM Radio on Instagram: "Mratibu wa Maafa kutoka Ofisi ya Waziri Mkuu, Yona Benjamin, akieleza kuhusu mashirika yanayoshirikiana na Serikali katika utoaji wa misaada ya kibinadamu kwa wananchi, pamoja na kongamano litakalofanyika Agosti 18 kwa lengo la kujifunza kwa pamoja namna bora ya kutoa misaada ya kibinadamu."',
    url: "https://www.instagram.com/reel/DcIfEVyka-h",
    platform: "Instagram",
    thumbnail: "/assets/ufmradio.png",
  },
  {
    id: 3,
    title: "BARAGUMU LIVE / KUELEKEA SIKU YA KIMATAIFA YA MISAADA YA KIBINADAM",
    url: "https://youtu.be/tJKTYrmDqFU?si=NJHJU_gwnJlCwNin",
    platform: "YouTube",
    thumbnail: "https://i.ytimg.com/vi/tJKTYrmDqFU/hqdefault.jpg",
  },
  {
    id: 4,
    title: "BARAGUMU LIVE / WIKI YA UTOAJI WA MISAADA YA KIBINADAMU",
    url: "https://youtu.be/W_rthOnQLpw?si=94FHiqPtRaKO_ecO",
    platform: "YouTube",
    thumbnail: "https://i.ytimg.com/vi/W_rthOnQLpw/hqdefault.jpg",
  },
  {
    id: 1,
    title: "Facilitation of World Humanitarian Day in Tanzania 2024 and 2025",
    images: [
      {
        src: "/assets/event.jpeg",
        alt: "World Humanitarian Day 2024 commemoration at JICC, Dar es Salaam",
      },
      {
        src: "/assets/event2.jpeg",
        alt: "World Humanitarian Day 2025 commemoration in Dodoma",
      },
    ],
  },
];

const LINK_ACTIVITIES = LATEST_ACTIVITIES.filter((activity) => activity.url);
const GALLERY_ACTIVITIES = LATEST_ACTIVITIES.filter((activity) => activity.images);

const CATEGORIES = [
  "All",
  "Disaster Response",
  "Preparedness",
  "Coordination",
  "Humanitarian Day",
  "Membership",
  "Announcement",
];

const categoryStyles = {
  "Disaster Response": "bg-red-500/10 text-red-400 border-red-500/20",
  Preparedness: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  Coordination: "bg-blue-500/10 text-blue-400 border-blue-500/20",
  "Humanitarian Day": "bg-[#00E5CC]/10 text-[#00E5CC] border-[#00E5CC]/20",
  Membership: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  Announcement: "bg-purple-500/10 text-purple-400 border-purple-500/20",
};

function useInView(threshold = 0.15) {
  const [inView, setInView] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node || inView) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setInView(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [inView, threshold]);

  return [ref, inView];
}

function useCounter(target, duration = 1800, shouldStart = true) {
  const [value, setValue] = useState(typeof target === "number" ? 0 : target);

  useEffect(() => {
    if (typeof target !== "number") {
      setValue(target);
      return undefined;
    }

    if (!shouldStart) {
      setValue(0);
      return undefined;
    }

    let rafId = null;
    let startTime = null;

    const tick = (time) => {
      if (!startTime) {
        startTime = time;
      }
      const progress = Math.min((time - startTime) / duration, 1);
      setValue(Math.round(progress * target));
      if (progress < 1) {
        rafId = requestAnimationFrame(tick);
      }
    };

    rafId = requestAnimationFrame(tick);
    return () => {
      if (rafId) {
        cancelAnimationFrame(rafId);
      }
    };
  }, [duration, shouldStart, target]);

  return value;
}

const lineClampStyle = {
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
};

const excerptClampStyle = {
  display: "-webkit-box",
  WebkitLineClamp: 3,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
};

const NewsCard = ({ article, index }) => {
  const [cardRef, cardInView] = useInView(0.15);

  return (
    <article
      ref={cardRef}
      className="group cursor-pointer overflow-hidden rounded-2xl border border-white/10 bg-gradient-to-br from-slate-800/80 to-slate-900/80 transition-all duration-500 hover:border-[#00E5CC]/40 hover:shadow-[0_0_30px_rgba(0,229,204,0.10)]"
      style={{
        opacity: cardInView ? 1 : 0,
        transform: cardInView ? "translateY(0px)" : "translateY(20px)",
        transitionDelay: `${index * 60}ms`,
      }}
    >
      <div className="h-48 overflow-hidden bg-slate-700/50">
        <img
          src={article.image}
          alt={article.headline}
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
          loading="lazy"
        />
      </div>
      <div className="p-6">
        <div className="mb-3 flex items-center justify-between gap-3">
          <span
            className={`rounded-full border px-3 py-1 text-xs ${
              categoryStyles[article.category]
            }`}
          >
            {article.category}
          </span>
          <span className="text-xs text-slate-500">{article.date}</span>
        </div>
        <h3
          className="mb-3 font-bold leading-snug text-white transition-colors group-hover:text-[#00E5CC]"
          style={lineClampStyle}
        >
          {article.headline}
        </h3>
        <p
          className="mb-4 text-sm leading-relaxed text-slate-400"
          style={excerptClampStyle}
        >
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between border-t border-white/5 pt-4">
          <span className="text-xs text-slate-500">{article.author}</span>
          <div className="flex items-center gap-3">
            <span className="text-xs text-slate-500">{article.readTime}</span>
            <span className="text-sm text-[#00E5CC] opacity-0 transition-opacity group-hover:opacity-100">
              →
            </span>
          </div>
        </div>
      </div>
    </article>
  );
};

const ActivityCard = ({ activity, index }) => {
  const [cardRef, cardInView] = useInView(0.15);

  const cardStyle = {
    opacity: cardInView ? 1 : 0,
    transform: cardInView ? "translateY(0px)" : "translateY(20px)",
    transitionDelay: `${index * 80}ms`,
  };

  if (activity.url) {
    return (
      <article
        ref={cardRef}
        className="overflow-hidden rounded-3xl border border-white/10 bg-gradient-to-br from-slate-800/90 to-slate-900/90 transition-all duration-500 hover:border-[#00E5CC]/30 hover:shadow-[0_0_40px_rgba(0,229,204,0.08)]"
        style={cardStyle}
      >
        <a
          href={activity.url}
          target="_blank"
          rel="noopener noreferrer"
          className="group block"
        >
          {activity.thumbnail && (
            <div className="relative aspect-video overflow-hidden bg-slate-700/50">
              <img
                src={activity.thumbnail}
                alt=""
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 flex items-center justify-center bg-black/30 transition-colors group-hover:bg-black/40">
                <span className="flex h-14 w-14 items-center justify-center rounded-full border border-white/30 bg-black/50 text-2xl text-white">
                  ▶
                </span>
              </div>
            </div>
          )}
          <div className="border-t border-white/5 p-8">
            <span className="mb-3 inline-flex rounded-full border border-[#00E5CC]/20 bg-[#00E5CC]/10 px-3 py-1 text-xs text-[#00E5CC]">
              {activity.platform}
            </span>
            <h3 className="text-xl font-bold leading-snug text-white md:text-2xl">
              {activity.title}
            </h3>
            <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-[#00E5CC] transition-all duration-200 group-hover:gap-3">
              Watch on {activity.platform} →
            </span>
          </div>
        </a>
      </article>
    );
  }

  return (
    <article
      ref={cardRef}
      className="overflow-hidden rounded-3xl border border-white/10 bg-gradient-to-br from-slate-800/90 to-slate-900/90 transition-all duration-500 hover:border-[#00E5CC]/30 hover:shadow-[0_0_40px_rgba(0,229,204,0.08)]"
      style={cardStyle}
    >
      <div className="grid grid-cols-1 gap-0 sm:grid-cols-2">
        {activity.images.map((image) => (
          <div key={image.src} className="aspect-[4/3] overflow-hidden bg-slate-700/50">
            <img
              src={image.src}
              alt={image.alt}
              className="h-full w-full object-cover transition-transform duration-700 hover:scale-105"
              loading="lazy"
            />
          </div>
        ))}
      </div>
      <div className="border-t border-white/5 p-8">
        <span className="mb-3 inline-flex rounded-full border border-[#00E5CC]/20 bg-[#00E5CC]/10 px-3 py-1 text-xs text-[#00E5CC]">
          Humanitarian Day
        </span>
        <h3 className="text-xl font-bold leading-snug text-white md:text-2xl">
          {activity.title}
        </h3>
      </div>
    </article>
  );
};

const QuickLinkTile = ({ icon, title, description, link, index, onClick }) => {
  const [tileRef, tileInView] = useInView(0.2);

  return (
    <div
      ref={tileRef}
      className="rounded-2xl border border-white/10 bg-white/5 p-6 text-center transition-all duration-300 hover:border-[#00E5CC]/30"
      style={{
        opacity: tileInView ? 1 : 0,
        transform: tileInView ? "translateY(0px)" : "translateY(20px)",
        transitionDelay: `${index * 60}ms`,
      }}
    >
      <div className="mb-3 text-3xl">{icon}</div>
      <h3 className="mb-2 text-base font-bold text-white">{title}</h3>
      <p className="mb-4 text-sm leading-relaxed text-slate-400">{description}</p>
      <button
        type="button"
        onClick={onClick}
        className="text-sm text-[#00E5CC]"
      >
        {link}
      </button>
    </div>
  );
};

export default function NewsPage() {
  const [searchQuery, setSearchQuery] = useState("");
  const [activeCategory, setActiveCategory] = useState("All");
  const [visibleCount, setVisibleCount] = useState(6);
  const [emailInput, setEmailInput] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  const [gridRef, gridInView] = useInView(0.15);
  const animatedVisibleCount = useCounter(
    Math.min(visibleCount, ARTICLES.length),
    900,
    true
  );

  const featuredArticle = ARTICLES[0];
  const filteredArticles = ARTICLES.filter(
    (a) =>
      (activeCategory === "All" || a.category === activeCategory) &&
      (searchQuery === "" ||
        a.headline.toLowerCase().includes(searchQuery.toLowerCase()) ||
        a.excerpt.toLowerCase().includes(searchQuery.toLowerCase()) ||
        a.category.toLowerCase().includes(searchQuery.toLowerCase()))
  );
  const visibleArticles = filteredArticles.slice(0, visibleCount);

  return (
    <div className="min-h-screen bg-[#0B1629] text-white">
      <section className="relative overflow-hidden pb-20 pt-36">
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute left-1/2 top-1/2 h-[380px] w-[750px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#00E5CC]/5 blur-3xl" />
          <div className="absolute right-16 top-20 h-60 w-60 rounded-full bg-teal-400/5 blur-2xl" />
          <div className="absolute bottom-10 left-10 h-48 w-48 rounded-full bg-[#00E5CC]/3 blur-2xl" />
        </div>
        <div className="relative mx-auto max-w-4xl px-6 text-center">
          <span className="mb-6 inline-block rounded-full border border-[#00E5CC]/30 px-4 py-1.5 text-xs uppercase tracking-[0.25em] text-[#00E5CC]">
            LATEST NEWS &amp; UPDATES
          </span>
          <h1 className="mb-6 text-5xl font-black leading-tight text-white md:text-7xl">
            News, Updates &amp;
            <br />
            <span className="text-[#00E5CC]">Field Reports</span>
          </h1>
          <p className="mx-auto max-w-2xl text-lg leading-relaxed text-slate-400">
            Stay informed on DINGONET&apos;s latest coordination activities,
            disaster responses, humanitarian events, and network announcements
            from across Tanzania.
          </p>
        </div>
      </section>

      <section className="mx-auto w-full max-w-6xl px-6 pb-16">
        <div className="mb-6 flex items-center">
          <span className="mr-2 h-2 w-2 rounded-full bg-[#00E5CC]" />
          <span className="text-xs uppercase tracking-widest text-slate-400">
            LATEST ACTIVITIES
          </span>
        </div>
        <div className="space-y-6">
          {LINK_ACTIVITIES.map((activity, index) => (
            <ActivityCard key={activity.id} activity={activity} index={index} />
          ))}
        </div>
      </section>

      <section className="mx-auto w-full max-w-6xl px-6 pb-16">
        <div className="mb-6 flex items-center">
          <span className="mr-2 h-2 w-2 animate-pulse rounded-full bg-red-400" />
          <span className="text-xs uppercase tracking-widest text-slate-400">
            FEATURED STORY
          </span>
        </div>

        <article className="group w-full overflow-hidden rounded-3xl border border-white/10 bg-gradient-to-br from-slate-800/90 to-slate-900/90 transition-all duration-500 hover:border-[#00E5CC]/30 hover:shadow-[0_0_50px_rgba(0,229,204,0.10)]">
          <div className="grid grid-cols-1 gap-0 md:grid-cols-2">
            <div className="relative h-72 overflow-hidden bg-gradient-to-br from-slate-700 to-slate-800 md:h-auto md:min-h-[380px]">
              <img
                src={featuredArticle.image}
                alt={featuredArticle.headline}
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-slate-900/60" />
            </div>
            <div className="flex flex-col justify-center p-10">
              <span
                className={`mb-4 inline-flex w-fit rounded-full border px-3 py-1 text-xs ${
                  categoryStyles[featuredArticle.category]
                }`}
              >
                {featuredArticle.category}
              </span>
              <p className="mb-3 text-xs uppercase tracking-wider text-slate-500">
                {featuredArticle.date}
              </p>
              <h2 className="mb-4 text-2xl font-black leading-tight text-white md:text-3xl">
                {featuredArticle.headline}
              </h2>
              <p className="mb-6 text-sm leading-relaxed text-slate-400">
                DINGONET successfully organized and led Tanzania&apos;s national
                World Humanitarian Day 2025 commemorations in Dodoma, officiated
                by the Prime Minister&apos;s Office. The event brought together
                government institutions, UN agencies, NGOs, and development
                partners to recognize and celebrate the work of humanitarian
                actors across the country — reinforcing national commitment to
                coordinated humanitarian action.
              </p>
              <button
                type="button"
                onClick={() => {
                  setActiveCategory(featuredArticle.category);
                  gridRef.current?.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  });
                }}
                className="flex items-center gap-2 text-sm font-semibold text-[#00E5CC] transition-all duration-200 hover:gap-3"
              >
                Read Full Story →
              </button>
            </div>
          </div>
        </article>
      </section>

      {GALLERY_ACTIVITIES.length > 0 && (
        <section className="mx-auto w-full max-w-6xl px-6 pb-16">
          <div className="space-y-6">
            {GALLERY_ACTIVITIES.map((activity, index) => (
              <ActivityCard key={activity.id} activity={activity} index={index} />
            ))}
          </div>
        </section>
      )}

      <section className="mx-auto w-full max-w-6xl px-6 pb-10">
        <div className="flex flex-col items-center gap-4 rounded-2xl border border-white/8 bg-white/3 p-5 md:flex-row">
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="🔍  Search news, events, reports..."
            className="w-full flex-1 rounded-full border border-white/10 bg-white/5 px-5 py-3 text-sm text-white placeholder-slate-500 outline-none transition focus:border-[#00E5CC]/40"
          />
          <div className="flex flex-wrap justify-center gap-2 md:justify-start">
            {CATEGORIES.map((category) => (
              <button
                key={category}
                type="button"
                onClick={() => setActiveCategory(category)}
                className={`cursor-pointer rounded-full px-4 py-1.5 text-xs transition ${
                  activeCategory === category
                    ? "border border-[#00E5CC]/30 bg-[#00E5CC]/15 text-[#00E5CC]"
                    : "border border-white/10 bg-white/5 text-slate-400 hover:border-white/20 hover:text-white"
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto w-full max-w-6xl px-6 pb-28">
        <div ref={gridRef} className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {visibleArticles.map((article, index) => (
            <NewsCard key={article.id} article={article} index={index} />
          ))}
        </div>

        {gridInView && visibleArticles.length === 0 && (
          <div className="py-20 text-center">
            <div className="mb-4 text-5xl">🔍</div>
            <h3 className="text-xl font-bold text-white">No articles found</h3>
            <p className="mt-2 text-sm text-slate-400">
              Try a different search term or category.
            </p>
          </div>
        )}
      </section>

      <section className="mx-auto w-full max-w-6xl px-6 pb-16 text-center">
        {visibleCount < ARTICLES.length && (
          <button
            type="button"
            onClick={() => setVisibleCount((prev) => prev + 3)}
            className="rounded-full border border-white/20 px-8 py-3 text-slate-300 transition-all duration-300 hover:border-[#00E5CC]/40 hover:bg-[#00E5CC]/5 hover:text-white"
          >
            Load More Stories
          </button>
        )}
        <p className="mt-3 text-xs text-slate-500">
          Showing {animatedVisibleCount} of {ARTICLES.length} stories
        </p>
      </section>

      <section className="mx-auto w-full max-w-4xl px-6 pb-28">
        <div className="rounded-3xl border border-[#00E5CC]/20 bg-gradient-to-br from-[#00E5CC]/10 to-[#00BFA5]/5 p-12 text-center">
          <div className="mb-4 text-5xl">📬</div>
          <h2 className="mb-3 text-3xl font-black text-white">Stay in the Loop</h2>
          <p className="mx-auto mb-8 max-w-md text-slate-400">
            Get DINGONET&apos;s latest news, disaster alerts, coordination updates,
            and network announcements delivered to your inbox.
          </p>
          <div className="mx-auto flex max-w-md flex-col gap-3 sm:flex-row">
            <input
              type="email"
              value={emailInput}
              onChange={(e) => setEmailInput(e.target.value)}
              placeholder="Enter your email address"
              className="flex-1 rounded-full border border-white/10 bg-white/5 px-5 py-3 text-sm text-white placeholder-slate-500 outline-none transition focus:border-[#00E5CC]/40"
            />
            <button
              type="button"
              onClick={() => {
                if (emailInput.trim() !== "") {
                  setSubscribed(true);
                }
              }}
              className="rounded-full bg-[#00E5CC] px-6 py-3 font-bold text-[#0B1629] transition hover:bg-[#00BFA5]"
            >
              Subscribe
            </button>
          </div>
          {subscribed && (
            <div className="mt-4">
              <p className="font-semibold text-[#00E5CC]">✅ You&apos;re subscribed!</p>
              <p className="mt-2 text-sm text-slate-400">
                Thank you for subscribing to DINGONET updates.
              </p>
            </div>
          )}
          <p className="mt-4 text-xs text-slate-600">
            We respect your privacy. Unsubscribe at any time.
          </p>
        </div>
      </section>

      <section className="mx-auto w-full max-w-6xl px-6 pb-24">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <QuickLinkTile
            icon="📁"
            title="Resources"
            description="Access DINGONET reports, guidelines, assessment tools, and coordination documents."
            link="Browse Resources →"
            index={0}
            onClick={() => {
              setSearchQuery("report");
              setActiveCategory("All");
              gridRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }}
          />
          <QuickLinkTile
            icon="🤝"
            title="Become a Member"
            description="Join Tanzania's leading humanitarian coordination network. Open to all qualifying NGOs."
            link="Apply Now →"
            index={1}
            onClick={() => {
              setSearchQuery("");
              setActiveCategory("Membership");
              gridRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }}
          />
          <QuickLinkTile
            icon="📞"
            title="Contact Secretariat"
            description="Reach the DINGONET Secretariat hosted at RAPID-Tanzania for inquiries and partnerships."
            link="Get in Touch →"
            index={2}
            onClick={() => {
              window.location.href = "mailto:info@dingonet.org";
            }}
          />
        </div>
      </section>

      <footer className="border-t border-white/5 py-8 text-center text-sm text-slate-500">
        <p>
          DINGONET Secretariat (Hosted by RAPID-Tanzania) · P.O. Box 11189, Dar
          es Salaam · info@dingonet.org · Executive Director 0757724717 · Lead of Advocacy and Communication 0744388179
        </p>
        <p className="mt-2">Reg. No. 8894 · Registered January 2026</p>
      </footer>
    </div>
  );
}
